import { createApp } from 'vue';
import App from './App.vue';
import AppSelect from './components/AppSelect.vue';
import './registerServiceWorker';
import { VueReCaptcha } from 'vue-recaptcha-v3'

import router from './router';
import store from './store';
import i18n, { resolveInitialLocale } from './i18n';
import axios from 'axios';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import './icons'
import { siteKey } from "@/constants";
import { loader } from "@/tools";

axios.defaults.headers.common['X-Locale'] = resolveInitialLocale();
axios.defaults.headers.common['Accept-Language'] = resolveInitialLocale();

createApp(App)
    .component('AppSelect', AppSelect)
    .component('icon', FontAwesomeIcon)
    .use(store)
    .use(router)
    .use(i18n)
    .use(VueReCaptcha, {
        siteKey: siteKey,
        loaderOptions: {
            useRecaptchaNet: true,
            autoHideBadge: true
        }
    })
    .mount('#app');

loader();
